module.exports = __webpack_public_path__ + "img/header.659205d0.png";